import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../utilities/cn';

export type PillStatus =
  | 'pass'
  | 'alert'
  | 'fail'
  | 'na'
  | 'neutral'
  | 'edit'
  | 'review'
  | 'review-complete'
  | 'demo';

const STATUS_CLASSES: Record<PillStatus, string> = {
  pass: 'bg-green-50 text-green-700 ring-green-200',
  alert: 'bg-amber-50 text-amber-700 ring-amber-200',
  fail: 'bg-red-50 text-red-700 ring-red-200',
  na: 'bg-gray-100 text-gray-700 ring-gray-200',
  neutral: 'bg-gray-100 text-gray-700 ring-gray-200',
  edit: 'bg-blue-50 text-blue-700 ring-blue-200',
  review: 'bg-purple-50 text-purple-700 ring-purple-200',
  'review-complete': 'bg-green-50 text-green-700 ring-green-200',
  demo: 'bg-demo_bg text-demo ring-demo/20 text-xs rounded-md',
};

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  status?: PillStatus;
  children: ReactNode;
}

export const Pill: FunctionComponent<PillProps> = ({
  status = 'neutral',
  className,
  children,
  ...props
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset',
        STATUS_CLASSES[status],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export default Pill;
